var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VBtn',{staticClass:"focus:outline-none",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click')}}},[_c('VIcon',{attrs:{"medium":""}},[_vm._v("mdi-reload")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }